import React, { useEffect, useRef, useState } from 'react'
import styles from './activeSchedule.module.css'

import { useLocation, useNavigate } from "react-router-dom";
import cleanerOne from "../../../assets/cleanerOne.png";
import cleanerTwo from "../../../assets/cleanerTwo.png";
import plusIcon from "../../../assets/plusIcon.png";
import { List, Modal } from "antd";
import { AntdDropdown, SearchInput } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ScheduleMiddleware from '../../../store/Middlewares/ScheduleMiddleware';
import moment from 'moment';
import { roles } from '../../../config/roles';
import { MdClear } from 'react-icons/md';


const ActiveSchedule = () => {

  useEffect(() => {
    getActiveSchedule()
    getLanguage();
  }, []);

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const user = useSelector((state) => state.AuthReducer.user)
  const timeout = useRef(null);
  const [search, setSearch] = useState('');
  const role = localStorage.getItem('role')
  const ActiveScheduleList = useSelector(
    state => state.ScheduleReducer.ActiveScheduleList,
  );
  const ActiveScheduleListPagination = useSelector(
    state => state.ScheduleReducer.ActiveScheduleListPagination,
  );
  const { state } = useLocation()
  console.log('state', state)
  const [isModalOpen, setIsModalOpen] = useState(state?.wofCreatedModal ? true : false);
  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const getActiveSchedule = () => {
    let data = {
      next_page_url: undefined,
      search: search,
      Status: 'active',
    };
    dispatch(ScheduleMiddleware.getActiveSchedule(data));
  };

  const onPressLoadMore = () => {
    let data = {
      search: search,
      next_page_url: ActiveScheduleListPagination?.links?.next,
      Status: 'active',
    };
    dispatch(ScheduleMiddleware.getActiveSchedule(data));
  };

  const onSearchActiveSchedule = text => {
    let data = {
      search: text,
      next_page_url: undefined,
      Status: 'active',
    };
    setSearch(text);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(ScheduleMiddleware.getActiveSchedule(data));
    }, 1000);
  };


  const handleChange = value => {
    console.log(value);
    if (value == 'Time_Sheet') {
      navigate('/schedule/TimeSheet')
    }
    else if (value == 'Calendar_Schedule') {
      navigate('/schedule/Calendar')
    }
  };

  const loadMore =
    ActiveScheduleListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  return (
    <div className={styles.createChecklist_mainContainer}>
      <div className={styles.filterCont}>
        <div className={styles.filterItem}>
          <SearchInput onChange={(e) => onSearchActiveSchedule(e.target.value)} placeholder={t("Search")} style={{ width: '100%' }} />
        </div>
        <div className={styles.filterItem}>
          <AntdDropdown
            // name={'Status'}
            // label={'Role'}
            placeholder={t('Calendar Schedule')}
            className={'yellow_border_class'}
            onChange={handleChange}
            options={
              role == roles.contractor ? [{ value: 'Calendar_Schedule', option: t('Calendar Schedule')},
              { value: 'Time_Sheet', option: t('Time Sheet') }] : [{ value: 'Calendar_Schedule', option: t('Calendar Schedule') }]}
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          />
        </div>
      </div>
      <List
        grid={{
          gutter: 16,
          //   xs: 2,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 2,
          xxl: 2,
        }}
        // className={styles.createChecklist_list}
        dataSource={ActiveScheduleList}
        footer={loadMore}
        style={{ width: '100%' }}
        renderItem={(item) => (
          <div key={item?.id} className={styles.createChecklist_listItem}>
            <div className={styles.createChecklist_context}>
              <div className={styles.createChecklist_heading}>
                <h3>{item?.date ? moment(item?.date).format('MM-DD-YYYY') : null}</h3>
              </div>
              <div className={styles.dataCont}>
                {role != roles.customer && <div style={{ width: '100%' }}>
                  <p className={styles.schedule_heading}>{t("Customer Name")}</p>
                  <p className={styles.createChecklist_para}>{item?.customer_name}</p>
                </div>}
                <div style={{ width: '100%' }}>
                  <p className={styles.schedule_heading}>{t("Cleaner Name")}</p>
                  <p className={styles.createChecklist_para}>{item?.cleaner_name}</p>
                </div>
                <div style={{ width: '100%' }}>
                  <p className={styles.schedule_heading}>{t("Category")}</p>
                  <p className={styles.createChecklist_para}>{item?.service_type}</p>
                </div>
              </div>
              <div className={styles.dataCont}>
                <div style={{ width: '100%' }}>
                  <p className={styles.schedule_heading}>{t("Time")} </p>
                  <p className={styles.createChecklist_para}>{moment('01 jan 1940 ' + item?.start_time).format('LT') + ' - ' + moment('01 jan 1940 ' + item?.end_time).format('LT')}</p>
                </div>
                {role != roles.customer &&
                  <div style={{ width: '100%' }}>
                    <p className={styles.schedule_heading}>{t("Hours")}</p>
                    <p className={styles.createChecklist_para}>{item?.estimated_working_hours}</p>
                  </div>}
                <div style={{ width: '100%' }}>
                  <p className={styles.schedule_heading}>{t("Location")}</p>
                  <p className={styles.createChecklist_para}>{item?.location?.address}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      />
      <Modal
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
        }}
        closable={false}
        footer={null}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
      // width={700}
      >
        <div style={{ display: "flex", justifyContent: "right" }} >
          <MdClear style={{ cursor: "pointer" }} color="#FFFFFF" size={25} onClick={() => setIsModalOpen(false)} />
        </div>
        <div className={styles.modalTxt}>
          <h3>Request has been created</h3>
          <h1>Successfully</h1>
        </div>

      </Modal>
    </div>
  );
};

export default ActiveSchedule